export const sortOpenedEntities = (a: any, b: any) => b.timestamp - a.timestamp;
